import { requestApi, parseResponse } from '~/services/api-new';
import { createImageViewFactory, generateCampaignImageSrcSetFactory } from '~/components/utilities/image-format';
import getGameUrls from '~/components/casino-shared/utilities/getGameUrls';
import enhanceImageView from '~/components/casino-shared/utilities/enhanceImage';

const host = '/';

const enhanceLiveData = async (payload, state) => {
	const response = parseResponse(
		await requestApi({
			endpoint: `${host}${`rest/state/casino/explore/live-on-web`}`,
			additionalOptions: { cache: 'default' }
		})
	);

	const gameNamesByIdx = state.gameNamesByIdx.slice();
	const gameCodesByProviderCode = { ...state.gameCodesByProviderCode };
	const gameCodesBySubProviderCode = { ...state.gameCodesBySubProviderCode };

	const gameCodesByPublishCode = { ...state.gameCodesByPublishCode };
	const gameCodesByIdx = state.gameCodesByIdx.slice();

	const providers = { ...state.providers };
	const subProviders = { ...state.subProviders };

	const {
		isPictureElementEnabled,
		imageDescriptors,
		imageFormats,
		campaignBackgroundImageDescriptors,
		campaignForegroundImageDescriptors
	} = payload;

	const formatEnhancer = isPictureElementEnabled && createImageViewFactory(imageFormats, imageDescriptors);

	const enhanceCampaignImage = generateCampaignImageSrcSetFactory(
		campaignBackgroundImageDescriptors,
		campaignForegroundImageDescriptors
	);

	const { campaigns, categories, games } = response;

	const enhancedGames = games.reduce((acc, currGame, gameIndex) => {
		const game = { ...currGame, ...getGameUrls(currGame) };

		gameNamesByIdx[gameIndex] = game.name;
		gameCodesByIdx[gameIndex] = game.code;

		const publishCode = game.publishCode?.split('_').reverse()[0];
		gameCodesByPublishCode[publishCode] = game.code;

		if (game.imageView) {
			game.imageView = enhanceImageView(game.imageView, imageDescriptors, formatEnhancer, false);
		}

		if (gameCodesByProviderCode[game.provider.code]) {
			gameCodesByProviderCode[game.provider.code].push(game.code);
		} else {
			gameCodesByProviderCode[game.provider.code] = [game.code];
		}
		if (game.casinoSubProvider) {
			if (gameCodesBySubProviderCode[game.casinoSubProvider]) {
				gameCodesBySubProviderCode[game.casinoSubProvider].push(game.code);
			} else {
				gameCodesBySubProviderCode[game.casinoSubProvider] = [game.code];
			}

			// TODO fix when code is available
			subProviders[game.casinoSubProvider] = {
				name: game.casinoSubProvider,
				code: game.casinoSubProvider
			};
		}

		providers[game.provider.code] = { ...game.provider };

		acc[game.code] = game;

		return acc;
	}, {});

	const enhancedCampaigns = campaigns.map(banner => ({
		...banner,
		backgroundImage: enhanceCampaignImage(banner.backgroundImage, 'background'),
		foregroundImage1: banner.foregroundImage1
			? enhanceCampaignImage(banner.foregroundImage1, 'foreground')
			: undefined,
		foregroundImage2: banner.foregroundImage2
			? enhanceCampaignImage(banner.foregroundImage2, 'foreground')
			: undefined,
		tcImage: banner.tcImage ? enhanceCampaignImage(banner.tcImage, 'foreground') : undefined
	}));

	const enhancedCategories = categories.map(({ gamesByIdx, winners, ...rest }) => ({
		...rest,
		...(gamesByIdx
			? {
					gameCodes: gamesByIdx.map(index => games[index].code)
			  }
			: null),
		...(winners
			? {
					winners: winners.map(({ gameIdx, ...winnersRest }) => ({
						...winnersRest,
						gameCode: games[gameIdx].code
					}))
			  }
			: null)
	}));
	return {
		games: enhancedGames,
		gameCodesByIdx,
		gameNamesByIdx,
		gameCodesByProviderCode,
		gameCodesBySubProviderCode,
		gameCodesByPublishCode,
		providers,
		subProviders,
		campaigns: enhancedCampaigns,
		exploreCategories: enhancedCategories
	};
};

export default enhanceLiveData;
